import { Site } from 'src/models/Site';
import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';

export const useCorporationSites = (corporationId: number) => {
    return useSWR<Site[]>(`/corporations/${corporationId}/sites`, swrFetch);
};
